// src/pages/Auditorias/components/AuditoriaFiltros.js
import React from 'react';

/**
 * `mostrarAdvogados` — só administradores veem auditorias de mais do que uma
 * pessoa. Para os restantes o servidor já filtra pelo próprio, e um selector
 * com uma opção única só ocupava espaço.
 */
const AuditoriaFiltros = ({ filtros, advogados, onMudar, mostrarAdvogados = true }) => (
  <div className="aud-filtros">
    <input
      type="text"
      placeholder="Cliente ou processo"
      value={filtros.procura}
      onChange={(e) => onMudar('procura', e.target.value)}
    />

    {mostrarAdvogados && (
      <select value={filtros.advogado} onChange={(e) => onMudar('advogado', e.target.value)}>
        <option value="">Todos os advogados</option>
        {advogados.map((a) => (
          <option key={a.user_email} value={a.user_email}>
            {a.user_email} ({a.total})
          </option>
        ))}
      </select>
    )}

    <select value={filtros.estado} onChange={(e) => onMudar('estado', e.target.value)}>
      <option value="">Todos os estados</option>
      <option value="concluida">Concluída</option>
      <option value="em_execucao">Em execução</option>
      <option value="pendente">Pendente</option>
      <option value="erro">Erro</option>
    </select>

    <select value={filtros.validacao} onChange={(e) => onMudar('validacao', e.target.value)}>
      <option value="">Toda a validação</option>
      <option value="pendente">Por validar</option>
      <option value="validada">Validada</option>
    </select>
  </div>
);

export default AuditoriaFiltros;
